import Cars from "@views/Cars"
import { allPathsCarsQuery, makeModelYearQuery } from "@views/Cars/graphql"
import requestStaticProps from "@utils/requestStaticProps"
import requestProducts from "@utils/requestProducts"
import runCompatibilityFilter from "@utils/runCompatibilityFilter"
import { GetStaticPaths, GetStaticProps } from "next"
import _ from "lodash"

export default Cars

export const getStaticPaths: GetStaticPaths = async () => {
  return { paths: [], fallback: true }
}

export const getStaticProps: GetStaticProps = async ({
  params,
  preview = false,
}) => {
  const { data: pathsData, error: pathsError } =
    (await requestStaticProps(allPathsCarsQuery)) || {}

  if (pathsError) {
    console.error(pathsError)
  }

  const allCars = pathsData?.allCars || []

  const thisCar = allCars.find((car: any) => {
    return (
      params?.make === car.make?.slug &&
      params?.model === car.model?.slug &&
      !car.trim
    )
  })

  const validYear = params?.year && thisCar?.years?.indexOf(params.year) !== -1

  const { data, error, dataLoaded } =
    thisCar && validYear
      ? await requestProducts(makeModelYearQuery, {
          makeId: [thisCar.make.id],
          modelId: thisCar.model.id,
          year: params?.year,
        })
      : {
          data: {},
          error: undefined,
          dataLoaded: false,
        }

  if (error) {
    console.error(error)
  }

  const filteredProducts =
    (thisCar &&
      data &&
      runCompatibilityFilter({
        products: data?.allProducts || [],
        make: thisCar.make,
        model: thisCar.model,
        year: params?.year,
      })) ||
    []

  const mergedData = {
    ...data,
    ..._.pick(pathsData, [
      "collectionsConfiguration",
      "allTrims",
      "allProductCategories",
      "allProductStyles",
    ]),
    allProducts: filteredProducts.filter(
      (product) => product.module == "automotive"
    ),
  }

  return {
    props: {
      title: thisCar
        ? `${params?.year} ${thisCar.make.name} ${thisCar.model.name}`
        : "",
      make: thisCar?.make ?? null,
      model: thisCar?.model ?? null,
      year: params?.year ?? null,
      data: mergedData,
      dataLoaded: !!dataLoaded,
    },
  }
}
